import axios from 'axios';
import config from './config';
import router from '@/router';
import { Message } from '@/utils/resetPopup';

/**
 * 【per-user HttpOnly Cookie 认证方案 - WMS 实例】
 * - token 全部由浏览器自动携带 HttpOnly Cookie，Stone-wms JwtTokenUtils.getToken() 从 Cookie 读
 * - 前端 sessionStorage 只存 current_user（当前用户名），不再存 token
 * - 与 axios.js 公用一个 USER_KEY，clearTokens() 行为一致
 */

const USER_KEY = 'user';

function getCurrentUser() {
  return sessionStorage.getItem(USER_KEY) || '';
}

export function clearTokens() {
  sessionStorage.removeItem(USER_KEY);
}

async function refreshAccessToken() {
  try {
    // refresh_token 在 HttpOnly Cookie 中，浏览器自动发送
    const resp = await axios.create({
      baseURL: config.baseUrl || '',
      withCredentials: true
    }).post('/api/token/refresh', {});
    if (resp.data && resp.data.data && resp.data.data.access_token) {
      // token 已写入 HttpOnly Cookie，前端无需再存
      return resp.data.data.access_token;
    }
  } catch (e) {
    console.error('WMS refresh token failed:', e);
  }
  return null;
}

const instance = axios.create({
  baseURL: '/wmsApi',  // → stone-wms:9001
  headers: config.headers,
  timeout: config.timeout || 60000,
  withCredentials: true
});

// ── 请求拦截器：写 user Cookie，附加 Authorization header────────────
instance.interceptors.request.use(
  config => {
    const currentUser = getCurrentUser();
    if (currentUser) {
      document.cookie = `user=${currentUser}; Path=/; SameSite=Lax`;
    }
    delete config.headers['Authorization'];
    delete config.headers['token'];
    return config;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    const origRequest = error.config;

    if (error.response && error.response.status === 401 && origRequest && !origRequest._retry) {
      origRequest._retry = true;

      const newToken = await refreshAccessToken();
      if (newToken) {
        // token 已写入 Cookie，重试请求会自动携带
        return instance(origRequest);
      } else {
        clearTokens();
        router.push('/login');
        return Promise.reject(error);
      }
    }

    if (error.response) {
      switch (error.response.status) {
        case 400:  error.message = '请求错误'; break;
        case 401:  error.message = '未授权，请登录'; break;
        case 403:  error.message = '拒绝访问'; break;
        case 404:  error.message = '请求地址出错'; break;
        case 405:  error.message = '您的账号已在其他设备登录'; break;
        case 408:  error.message = '请求超时'; break;
        case 500:  error.message = '服务器内部错误'; break;
        case 502:  error.message = '网关错误'; break;
        case 503:  error.message = '服务不可用'; break;
        case 504:  error.message = '网关超时'; break;
      }
      if (error.response.status === 401 || error.response.status === 405) {
        clearTokens();
        router.push('/login');
      }
    }
    console.error(error);
    return Promise.reject(error);
  }
);

export default instance;


// WEBPACK FOOTER //
// ./src/http/wmsAxios.js